import React, { FC } from 'react';
import { FooterLink } from '../../../../types/types';
import { FooterLinkModel } from '../../../../lib/shared-models/FooterLink.model';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';

const Navigation: FC<FooterLink> = (props) => {
  const model = new FooterLinkModel(props);
  const items = model.list?.map((item: FooterLink) => {
    return (
      <li key={item?.id} className="footer-navigation__item">
        {item?.fields?.isModalPopup?.value ? (
          // external consent cookie notice button
          <button id="ot-sdk-btn" className="ot-sdk-show-settings footer-navigation__cookieBtn">
            {item?.fields?.link?.value?.text || item?.fields?.link?.value?.href}
          </button>
        ) : (
          <RoutableSitecoreLink field={item?.fields?.link} className="footer-navigation__link" />
        )}
      </li>
    );
  });
  return <ul className="footer-navigation">{items}</ul>;
};

export default Navigation;
